import _styled from"@emotion/styled";import{Checkbox,mediaQuery}from"@wp/src/components/common";import{Form,FormItem}from"@wp/src/components/common/form";export const FormContainer=_styled.div`
  padding: 0 0 16px 0;
`;export const UpdateInvestmentAmountContainer=_styled.div``;export const InputHeaderLabel=_styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;

  color: ${props=>props.theme.colors.neutral600};
`;export const StyledForm=_styled(Form)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 8px;

  ${mediaQuery({flexWrap:["wrap","wrap","wrap","nowrap"]})}

  & > :not(:last-child) {
    margin-bottom: 8px;
    margin-right: 8px;
  }
`;export const AmountInputFormItem=_styled(FormItem)`
  width: 196px;
  max-width: 196px;
`;export const AmountLabelContainer=_styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;

  color: ${props=>props.theme.colors.neutral900};
  padding-top: 16px;
`;export const OptimalAmountContainer=_styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  color: ${props=>props.theme.colors.neutral500};
`;export const MoneyMarketCheckbox=_styled(Checkbox)`
  display: inline-flex;
  align-items: center;
  flex-shrink: 1;
  max-width: 296px;
`;